import { isUserApiError } from '../api/client'

export const deviceResultStatuses = [
  'success',
  'returning',
  'safe-close',
  'reopen-client',
  'canceled',
  'expired',
  'used',
  'invalid',
  'proof-failed',
  'rate-limited',
  'device-limit',
  'device-revoked',
  'service-unavailable',
  'unsupported-key',
  'callback-failed',
  'step-up-required',
] as const

export type DeviceResultStatus = typeof deviceResultStatuses[number]

export function normalizeDeviceResultStatus(value: unknown): DeviceResultStatus {
  return typeof value === 'string' && (deviceResultStatuses as readonly string[]).includes(value)
    ? value as DeviceResultStatus
    : 'invalid'
}

export function deviceResultFromError(reason: unknown): DeviceResultStatus {
  if (reason instanceof Error && reason.message === 'secure_device_key_unsupported') return 'unsupported-key'
  if (!isUserApiError(reason)) return 'service-unavailable'
  const exact = ({
    callback_approval_not_pending: 'invalid',
    device_authorization_invalid: 'invalid',
    device_authorization_rejected: 'proof-failed',
    device_authorization_conflict: 'invalid',
    device_authorization_limited: 'rate-limited',
    device_authorization_unavailable: 'service-unavailable',
    hive_session_exchange_unavailable: 'service-unavailable',
    hive_session_refresh_unavailable: 'service-unavailable',
    session_exchange_service_unavailable: 'service-unavailable',
    user_oidc_not_configured: 'service-unavailable',
    invalid_oidc_callback: 'invalid',
    session_exchange_invalid_request: 'invalid',
    session_exchange_device_authorization_unavailable: 'invalid',
    session_exchange_device_revoked: 'device-revoked',
    session_exchange_state_conflict: 'invalid',
    session_not_established: 'service-unavailable',
    session_expired: 'expired',
    step_up_rejected: 'step-up-required',
  } as Record<string, DeviceResultStatus>)[reason.code ?? '']
  if (exact) return exact
  return reason.status >= 500 ? 'service-unavailable' : 'invalid'
}
